import { retryCancelablePromise } from '../core/utils/retryCancelablePromise';
export class BranchesService {
    constructor(httpRequest) {
        Object.defineProperty(this, "httpRequest", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: httpRequest
        });
    }
    /**
     * Get list of pull request templates for branches
     * @returns PullRequestTemplate OK.
     * @throws ApiError
     */
    listPullRequestTemplates({ orgId, projectId, branchName, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/branches/{branchName}/pull-request-templates', path: {
                'orgId': orgId,
                'projectId': projectId,
                'branchName': branchName,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get pull request template for branch
     * @returns string OK.
     * @throws ApiError
     */
    getPullRequestTemplate({ orgId, projectId, branchName, templatePath, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/branches/{branchName}/pull-request-templates/{templatePath}', path: {
                'orgId': orgId,
                'projectId': projectId,
                'branchName': branchName,
                'templatePath': templatePath,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get list of branches
     * @returns BranchesList OK.
     * @throws ApiError
     */
    listBranches({ orgId, projectId, after, before, sort = '-id', filter, limit = 10, search, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/branches', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, query: {
                'after': after,
                'before': before,
                'sort': sort,
                'filter': filter,
                'limit': limit,
                'search': search,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Create new branch
     * @returns Branch Created.
     * @throws ApiError
     */
    createBranch({ orgId, projectId, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'POST', url: '/orgs/{orgId}/projects/{projectId}/branches', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get branch by id
     * @returns Branch OK.
     * @throws ApiError
     */
    getBranchById({ orgId, projectId, branchId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/branches/{branchId}', path: {
                'orgId': orgId,
                'projectId': projectId,
                'branchId': branchId,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Delete branch by id
     * @returns void
     * @throws ApiError
     */
    deleteBranchById({ orgId, projectId, branchId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'DELETE', url: '/orgs/{orgId}/projects/{projectId}/branches/{branchId}', path: {
                'orgId': orgId,
                'projectId': projectId,
                'branchId': branchId,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Update branch
     * @returns Branch OK.
     * @throws ApiError
     */
    updateBranch({ orgId, projectId, branchId, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'PATCH', url: '/orgs/{orgId}/projects/{projectId}/branches/{branchId}', path: {
                'orgId': orgId,
                'projectId': projectId,
                'branchId': branchId,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Sync branches from git source
     * @returns void
     * @throws ApiError
     */
    syncBranches({ orgId, projectId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'POST', url: '/orgs/{orgId}/projects/{projectId}/branch-syncs', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
}
//# sourceMappingURL=BranchesService.js.map